import { Router } from '@angular/router';
import { Component } from '@angular/core';

@Component({
    selector: 'wep-page-not-found',
    templateUrl: './pageNotFound.html',
    host: {'class': 'page page--notFound'},
    styleUrls: ['./pageNotFound.scss']
})

export class PageNotFoundPageComponent {
    private router:Router;

    constructor(router:Router) {
        this.router = router;
    }

    public goToHome() : void {
        this.router.navigate(['/']);
    }
}
